module.exports = __webpack_public_path__ + "img/miss-circle.722a3c36.png";